// src/utils/platform.js
//
// Определение платформы и платформо-зависимые правила.
// В Capacitor — getPlatform() возвращает 'ios' | 'android' | 'web'.
// В обычном вебе вне Capacitor — 'web'.

let _platform = null;

export function getPlatform() {
  if (_platform) return _platform;
  try {
    // eslint-disable-next-line
    const { Capacitor } = require('@capacitor/core');
    _platform = Capacitor.getPlatform();
  } catch (e) {
    _platform = 'web';
  }
  return _platform;
}

export function isIOS() {
  return getPlatform() === 'ios';
}

export function isAndroid() {
  return getPlatform() === 'android';
}

export function isWeb() {
  return getPlatform() === 'web';
}

// На iOS нельзя регистрировать магазин (требование Apple).
// На Android и web — можно.
export function canRegisterShop() {
  return !isIOS();
}

// На iOS нельзя показывать раздел оплат / тарифов / биллинга
// (политика App Store 3.1.1 — внешние оплаты запрещены).
// На Android и web — можно.
export function canSeeBilling() {
  return !isIOS();
}
